
import { observer } from "mobx-react-lite";
import { Container, Header, Segment } from "semantic-ui-react";
import { useStore } from "../../app/stores/store";


export default observer( function ServerError() {
    const usStore = useStore();

    return (
        <Container>
            <Header as='h1' content='Server error' />
            {/* <Header sub as='h5' content={usStore.commonStore.serverError?.message} color='red' /> */}
            {/* <Header sub as='h5' content={usStore.commonStore.serverError} color='red' /> */}

            {usStore.commonStore.serverError?.details && (
                <Segment>
                    <Header as='h4' content='Stack trace' color='teal' />
                    <code style={{marginTop: '10px'}}>{usStore.commonStore.serverError.details}</code>
                </Segment>
            )}

            {/* {usStore.commonStore.serverError && ( //.
                <Segment>
                    <Header as='h4' content='Stack trace' color='teal' />
                    <code style={{marginTop: '10px'}}>{usStore.commonStore.serverError}</code>
                </Segment>
            )} */}

        </Container>
    )
})